/** Only explicit rollout flags enable preference reads; the API also gates collection. */
export function analyticsRolloutEnabled(
  runtime: unknown,
  runtimeRequired: boolean,
  localFlag: unknown,
): boolean {
  if (!runtimeRequired) return localFlag === "true";
  if (!runtime || typeof runtime !== "object") return false;
  const value = runtime as {
    environment?: unknown;
    analyticsEnabled?: unknown;
  };
  return (
    (value.environment === "staging" || value.environment === "production") &&
    value.analyticsEnabled === true
  );
}
